import { ICartItem } from '@/interfaces/ICart';

/*


export interface ICartItem {
  index: number;
  itemId: number;
  item: IItem;
  optionValues: Record<number, Record<number, number>>;
  unitPrice: number;
  quantity: number;
  totalPrice: number;
  userComment: string;
}
  */

/**
 *
 * @param item1
 * @param item2
 * @returns 'equal' if both the itemId, selected optionValues and amount are equal. 'amount' is itemId and selected optionValues are equal but amount are not. 'different' if itemId or selected optionValues are different.
 */
export function compareCartItems(
  item1: ICartItem,
  item2: ICartItem
): 'equal' | 'amount' | 'different' {
  // Check if itemIds are different
  if (item1.itemId !== item2.itemId) {
    return 'different';
  }

  if ((item1.userComment || '') !== (item2.userComment || '')) {
    return 'different';
  }

  // Function to generate a unique signature for optionValues
  function getOptionValuesSignature(
    optionValues: Record<number, Record<number, number>>
  ): string {
    const entries: Array<string> = [];

    for (const outerKey in optionValues) {
      const innerObj = optionValues[outerKey];
      for (const innerKey in innerObj) {
        entries.push(`${outerKey}_${innerKey}_${innerObj[innerKey]}`);
      }
    }

    // Sort the entries to ensure consistent order
    entries.sort();

    // Join entries to create a unique signature
    return entries.join('|');
  }

  // Generate signatures for optionValues
  const signature1 = getOptionValuesSignature(item1.optionValues);
  const signature2 = getOptionValuesSignature(item2.optionValues);

  // Compare optionValues signatures
  if (signature1 !== signature2) {
    return 'different';
  }

  // Compare quantities
  if (item1.quantity === item2.quantity) {
    return 'equal';
  } else {
    return 'amount';
  }
}
